import account from "./account";
import auth from "./auth";
import registrations from "./registrations";
import playgrounds from "./playgrounds";
import externalAuths from "./externalAuths";
import recruitments from "./recruitments";

const zeusAPI = {
  account,
  auth,
  registrations,
  playgrounds,
  externalAuths,
  recruitments,
};

export default zeusAPI;
